<template>
  <div class="flex items-baseline">
    <button @click="openCart" class="items-center p-8 align-middle cursor-pointer focus:outline-none">
      <span class="relative inline-block mb-4">
        <i class="far fa-shopping-cart text-2xl"></i>
        <span id="cartCount"
          class="absolute block w-16 h-16 font-bold leading-4 text-center text-white rounded-full -top-6 -right-6 lg:right-2 bg-orange text-12 lg:w-5 lg:h-5 lg:leading-5">
          {{ counter }}
        </span>
      </span>
    </button>

    <div ref="theCartMainPanel" id="cart-overlay"
      class="cart-panel overlay bg-transparent-dark-gray invisible cursor-pointer" @click="closeCart">
      <div id="cart-panel" class="navbar-animation content cursor-default bg-white transition-all ease-in-out duration-700 overflow-x-hidden overflow-y-scroll" @click.stop>
        <div class="sticky top-0 z-40 bg-white">
          <div class="p-26">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <i class="mr-12 far fa-shopping-cart text-22 md:text-26"></i>
                <h2 class="font-bold text-18">My Cart</h2>
              </div>
              <button @click="closeCart" class="focus:outline-none">
                <i class="fal fa-times text-24"></i>
              </button>
            </div>
          </div>
          <hr class="mb-20 text-light-gray-4" />
        </div>

        <!-- Cart Items -->
        <div v-if="counter > 0">
          <the-cart-panel-items v-for="item in items" :key="item.id" :item="item" @removed="remove" />

          <div class="px-20">
            <div class="flex justify-between py-20 border-t border-b border-light-gray-4">
              <h3 class="text-16">Total</h3>
              <h3 class="font-bold text-16">{{ total }}</h3>
            </div>

            <div class="w-full py-20">
              <a href="/checkouts/create">
                <button class="btn btn-primary-black focus:outline-none">
                  Checkout
                </button>
              </a>
            </div>
          </div>
        </div>

        <!-- Empty Cart -->
        <TheCartEmpty v-else></TheCartEmpty>

        <!-- Accepted Payment -->
        <div class="grid py-20 px-26 place-content-center">
          <div class="border-t border-b py-44 border-light-gray-4">
            <h2 class="font-bold text-center text-16">Accepted Payment Methods</h2>
            <div class="grid grid-cols-3 gap-24 pt-26">
              <div class="block">
                <div class="flex justify-center mb-14">
                  <img src="/assets/images/accepted-payment-methods/card_payment.png"
                    class="flex h-auto w-42 justify-items-center" alt="Credit / Debit Card" />
                </div>
                <p class="text-center">Credit / Debit Card</p>
              </div>
              <div class="block">
                <div class="flex justify-center mb-14">
                  <img src="/assets/images/accepted-payment-methods/OnlinePayment.svg" class="h-auto w-42"
                    alt="Online Payment" />
                </div>
                <p class="text-center">Online Payment</p>
              </div>
              <div class="block">
                <div class="flex justify-center mb-14">
                  <img src="/assets/images/accepted-payment-methods/Installment.svg" class="h-auto w-42"
                    alt="Installment" />
                </div>
                <p class="text-center">Installment</p>
              </div>
            </div>
          </div>
        </div>

        <div class="py-20 px-26" v-if="artworks.length > 0">
          <h2 class="mb-32 font-bold text-16 md:text-18">Suggested Artworks</h2>
          <TheCartCuratorPanel v-for="(artwork, index) in artworks.slice(-5)" :key="index" :artwork="artwork"
            :status="artwork.status" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheCartPanelItems from './../Modules/Cart/TheCartPanelItems.vue'
import TheCartEmpty from './../Modules/Cart/TheCartEmpty.vue'
import TheCartCuratorPanel from './../Modules/Cart/TheCartCuratorPanel.vue'

export default {
  name: "TheCartLink",

  components: {
    TheCartPanelItems,
    TheCartEmpty,
    TheCartCuratorPanel,
  },

  props: {
    status: { String },
  },

  data() {
    return {
      counter: 0,
      dropdownToggle: false,
      items: [],
      total: "",
      params: {},
      artworks: [],
      isLoading: true,
    };
  },

  created() {
    window.TheCartLink = this

    axios.get("/web/api/cart").then((success) => {
      this.counter = success.data.data.count
      this.fetchCuratorsPick()
    });

    this.params = new URLSearchParams({
      visitorId: getCookie("_ga"),
    });
  },

  methods: {
    openCart() {
      document.body.classList.add('overflow-hidden')
      document.getElementById("cart-overlay").classList.remove("invisible")
      document.getElementById("cart-panel").classList.add("active")
    },

    closeCart() {
      document.body.classList.remove('overflow-hidden')
      document.getElementById("cart-overlay").classList.add("invisible")
      document.getElementById("cart-panel").classList.remove("active")
    },

    fetchCuratorsPick() {
      if (this.counter > 0 || this.items.length > 0) {
        axios.get(this.api)
          .then(({ data: data }) => { this.artworks = data; })
          .finally(() => (this.isLoading = false))
      }
    },

    getItems() {
      axios.get("/web/api/cart/items").then(response => {
        this.items = response.data.data.items
        this.total = response.data.data.total
      }).finally(() => this.fetchCuratorsPick())
    },

    increment() {
      this.counter++
    },

    decrement() {
      this.counter--
    },

    remove(item) {
      this.items.splice(this.items.indexOf(item), 1)
      window.TheCartLink.decrement()
    },
  },

  computed: {
    label() {
      return "Cart";
    },

    highestPrice() {
      if (this.items.length > 1) {
        return this.items.reduce((prev, current) => {
          return prev.originalPrice > current.originalPrice
            ? prev.originalPrice
            : current.originalPrice
        })
      }

      if (this.items.length === 1) {
        return this.items[0].originalPrice
      }

      if (this.items.length === 0) {
        return 0;
      }
    },

    api() {
      return `/web/api/search/artworks/random-by-price?priceLimit=${this.highestPrice}`
    }
  },

  watch: {
    counter() {
      this.getItems()
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-panel {
  .content {
    position: fixed;
    top: 0;
    right: -800px;
    width: 100%;
    height: 100vh;
    border-left: 1px #cacaca solid;

    &.active {
      right: 0;
    }

    @media (min-width: 375px) {
      width: 320px;
    }

    @media (min-width: 425px) {
      width: 375px;
    }

    @media (min-width: 768px) {
      width: 480px;

    }
  }
}

@keyframes show-cart {
  0% {
    right: -800px;
  }

  100% {
    right: 0;
  }
}

@keyframes hide-cart {
  0% {
    right: 0;
  }

  100% {
    right: -800px;
  }
}
</style>
